enum RvType {
    // Motorized
    CLASS_A = 'Class A',
    CLASS_B = 'Class B',
    CLASS_C = 'Class C',

    // Non - motorized
    CAMPING_TRAILER = 'Camping Trailer',
    CARGO_TRAILER = 'Cargo Trailer',
    FIFTH_WHEEL = 'Fifth Wheel',
    FOLD_DOWN = 'Fold-Down',
    POP_UP_TRAILER = 'Pop-up Trailer',
    TEARDROP = 'Teardrop',
    TRAVEL_TRAILER = 'Travel Trailer',
    TRUCK_CAMPER = 'Truck Camper',
}

export default RvType
